import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-payment-discount-dialog',
  templateUrl: './payment-receipt-dialog.component.html',
  styleUrls: ['./payment-receipt-dialog.component.scss'],
})
export class PaymentReceiptDialogComponent {

  constructor(
    private dialogRef: MatDialogRef<PaymentReceiptDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: any
  ) {
  }

  submit() {
    this.dialogRef.close({
    });
  }
}
